import Vue from 'vue'
import Vuex from 'vuex'
import { getCookie, removeCookie, setCookie } from 'tiny-cookie'

let token = getCookie('token')
let user = {}
let logged = false

function parseJwtUser(tokenValue: string){
  if (!tokenValue){
    return {};
  }
  try {
    let payload = tokenValue.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
    while (payload.length % 4) {
      payload += '=';
    }
    return JSON.parse(atob(payload));
  } catch (e) {
    console.log("token parse error:", e);
    return {};
  }
}

if (token){
  user = parseJwtUser(token);
  logged = true
}

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    logged,
    user,
    organization: null,
    orgParams: {},
  },
  mutations: {
    setOrganization(state, organization){
      state.organization = organization;
      state.orgParams = {
        params: {
          organization_id: (organization || {}).id,
        },
      };
    },
    setUser(state, user){
      state.user = user
      state.logged = true
    },
    setSupportToken(state, token){
      setCookie('token', token, {path: '/'})
      try {
        if (window.location.hostname.endsWith('.aasp.org.br')) {
          setCookie('token', token, {path: '/', domain: '.aasp.org.br'})
        }
      } catch (e) {
        console.log('support token cookie domain error:', e);
      }
      state.user = parseJwtUser(token)
      state.logged = true
    },
    replaceUser(state, user){
      state.organization = null
      state.orgParams = {}
      state.user = user
      state.logged = true
    },
    replaceSupportToken(state, token){
      state.organization = null
      state.orgParams = {}
      setCookie('token', token, {path: '/'})
      try {
        if (window.location.hostname.endsWith('.aasp.org.br')) {
          setCookie('token', token, {path: '/', domain: '.aasp.org.br'})
        }
      } catch (e) {
        console.log('support token cookie domain error:', e)
      }
      state.user = parseJwtUser(token)
      state.logged = true
    },
    logout(state){
      state.user = {}
      state.logged = false
      state.organization = null
      state.orgParams = {}
      removeCookie('token')
      removeCookie('token', {domain: '.aasp.org.br'})
    },
  },
  actions: {}
})
